import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Caption } from 'components/Typography'
import { motion } from 'framer-motion'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SProtectTheMemory = styled.div`
  position: relative;

  @media ${BREAKPOINTS.MD.max} {
    min-height: 0;
    margin-top: 2rem;
  }
`

export const SProtectTheMemoryContent = styled.div<{ compact?: boolean }>`
  padding: 6.25rem;
  background-color: ${colors.gray[100]};
  position: relative;
  top: 0;
  left: -75px;

  ${({ compact }) =>
    compact
      ? `
          width: calc(100% + 150px); 
          min-height: 20rem;
          display: grid;
          grid-gap: 4rem;
          grid-template-columns: 1fr 1fr;
          align-items: center;`
      : `
          width: 47rem;
          min-height: 47rem;`};

  @media ${BREAKPOINTS.MD.max} {
    display: block;
    position: relative;
    left: calc(-5% * (100 / 90) - 2px);
    width: calc(100% + 10% * (100 / 90) + 4px);
    padding: 0;
    height: auto;
    min-height: unset;

    padding: calc(10% * (100 / 90)) calc(5% * (100 / 90));
  }
`

const jumpKeyframes = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
`

export const StepsGuideItem = styled.article`
  position: relative;
  @media ${BREAKPOINTS.MD.max} {
    padding-left: 20px;
  }
`

export const StepsGuideItemIcon = styled.div<{ active?: boolean }>`
  margin-bottom: 40px;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 10px;

    & svg {
      width: 1.375rem;
      min-width: 22px;
    }
  }

  ${({ active }) => {
    if (active) {
      return css`
        & svg {
          animation: ${jumpKeyframes} 0.6s 1 ease-in-out;
        }
      `
    }
    return null
  }}
`

export const StepsGuideItemSubtitle = styled(Caption)`
  margin-bottom: 10px;
`

export const StepsGuideItemProgress = styled(motion.div)`
  width: 100%;
  height: 2px;
  background: var(--c-blue500);
  position: absolute;
  top: 54px;

  @media ${BREAKPOINTS.MD.max} {
    height: 100%;
    width: 2px;
    top: 0;
    left: 0;
    bottom: 0;
  }
`

export const SCardWrapper = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(230)}rem, 1fr));
  grid-gap: 1rem;
  flex-wrap: wrap;
  justify-content: space-between;
  @media ${BREAKPOINTS.MD.max} {
    justify-content: center;
  }
`

export const SCard = styled.div`
  border: 2px solid #192a32;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  cursor: pointer;
`

export const SCoverImage = styled.div`
  position: absolute;
  z-index: -1;
  left: 0;
  right: -${pxToRem(75)}rem;
  bottom: -${pxToRem(75)}rem;
  top: ${pxToRem(75)}rem;

  width: 100%;
  object-fit: cover;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`
